// namespace (소문자)
export const NAMESPACE = 'mobile';
//actions
export const SELECT_MOBILE_TELECOMS = 'SELECT_MOBILE_TELECOMS';
export const SELECT_MOBILE_CATEGORY = 'SELECT_MOBILE_CATEGORY';
export const SELECT_MOBILE_DEVICE = 'SELECT_MOBILE_DEVICE';
export const SELECT_MOBILE_DEVICE_DETAIL = 'SELECT_MOBILE_DEVICE_DETAIL';
export const SELECT_MOBILE_PLAN_CATEGORY = 'SELECT_MOBILE_PLAN_CATEGORY';
export const SELECT_MOBILE_PLANS = 'SELECT_MOBILE_PLANS';
export const SELECT_MOBILE_PLAN_DETAIL = 'SELECT_MOBILE_PLAN_DETAIL';
export const INSERT_MOBILE_REQUESTS = 'INSERT_MOBILE_REQUESTS';
export const SELECT_MOBILE_COUPON = 'SELECT_MOBILE_COUPON';
export const SELECT_MOBILE_REQUEST_LIST_ING = 'SELECT_MOBILE_REQUEST_LIST_ING';
export const SELECT_MOBILE_REQUEST_LIST_END = 'SELECT_MOBILE_REQUEST_LIST_END';
export const SELECT_MOBILE_REQUEST_VIEW = 'SELECT_MOBILE_REQUEST_VIEW';
export const UPDATE_MOBILE_REQUEST_CLOSE = 'UPDATE_MOBILE_REQUEST_CLOSE';
export const UPDATE_MOBILE_PLAN = 'UPDATE_MOBILE_PLAN';
export const SELECT_MOBILE_ESTIMATE_LIST = 'SELECT_MOBILE_ESTIMATE_LIST';
export const SELECT_MOBILE_ESTIMATE_GROUP_LIST =
  'SELECT_MOBILE_ESTIMATE_GROUP_LIST';
export const SELECT_MOBILE_ESTIMATE_DETAIL = 'SELECT_MOBILE_ESTIMATE_DETAIL';
export const SELECT_MOBILE_SERVICE_LIST = 'SELECT_MOBILE_SERVICE_LIST';
export const INSERT_MOBILE_ESTIMATE = 'INSERT_MOBILE_ESTIMATE';
export const INSERT_MOBILE_PROMISE = 'INSERT_MOBILE_PROMISE';
export const SELECT_MOBILE_PROMISE = 'SELECT_MOBILE_PROMISE';
export const SELECT_MOBILE_PROMISE_LIST = 'SELECT_MOBILE_PROMISE_LIST';
export const SELECT_MOBILE_ESTIMATE_PREVIEW = 'SELECT_MOBILE_ESTIMATE_PREVIEW';
export const SELECT_MOBILE_ESTIMATE_NEW_CNT = 'SELECT_MOBILE_ESTIMATE_NEW_CNT';
export const UPDATE_MOBILE_ESTIMATE_VISIBLE = 'UPDATE_MOBILE_ESTIMATE_VISIBLE';
export const SELECT_MOBILE_PROMISE_NEW_CNT = 'SELECT_MOBILE_PROMISE_NEW_CNT';
export const SELECT_MOBILE_INSURANCE_LIST = 'SELECT_MOBILE_INSURANCE_LIST';
export const SELECT_MOBILE_PRODUCTS = 'SELECT_MOBILE_PRODUCTS';
export const UPDATE_MOBILE_BOOKMARK = 'UPDATE_MOBILE_BOOKMARK';
export const UPDATE_MOBILE_VIEW_PRODUCT = 'UPDATE_MOBILE_VIEW_PRODUCT';
export const UPDATE_MOBILE_SEL_PRODUCT = 'UPDATE_MOBILE_SEL_PRODUCT';
export const SELECT_MOBILE_REQUEST_CNT = 'SELECT_MOBILE_REQUEST_CNT';
export const SELECT_MOBILE_APPLY_LIST = 'SELECT_MOBILE_APPLY_LIST';
export const SELECT_MOBILE_CHAT_ESTIMATE_LIST =
  'SELECT_MOBILE_CHAT_ESTIMATE_LIST';
export const SELECT_MOBILE_APPLY_STATUS = 'SELECT_MOBILE_APPLY_STATUS';
export const UPDATE_MOBILE_APPLY_CANCEL = 'UPDATE_MOBILE_APPLY_CANCEL';
export const SELECT_MOBILE_APPLY_CNT_NEW = 'SELECT_MOBILE_APPLY_CNT_NEW';
export const SELECT_MOBILE_DEAL = 'SELECT_MOBILE_DEAL';
export const SELECT_MOBILE_DEAL_DETAIL = 'SELECT_MOBILE_DEAL_DETAIL';
export const MOBILE_DEAL_CHAT = 'MOBILE_DEAL_CHAT';
export const FETCH_MOBILE_ESTIMATE_RECENT = 'FETCH_MOBILE_ESTIMATE_RECENT';
export const SELECT_MOBILE_REQUEST_SAME_COUNT =
  'SELECT_MOBILE_REQUEST_SAME_COUNT';

//mutations
export const SET_MOBILE_TELECOMS = 'SET_MOBILE_TELECOMS';
export const SET_MOBILE_CATEGORY = 'SET_MOBILE_CATEGORY';
export const SET_MOBILE_DEVICE = 'SET_MOBILE_DEVICE';
export const SET_MOBILE_DEVICE_DETAIL = 'SET_MOBILE_DEVICE_DETAIL';
export const SET_MOBILE_PLAN_CATEGORY = 'SET_MOBILE_PLAN_CATEGORY';
export const SET_MOBILE_PLANS = 'SET_MOBILE_PLANS';
export const SET_MOBILE_PLAN_DETAIL = 'SET_MOBILE_PLAN_DETAIL';
export const SET_MOBILE_REQUEST_LIST_ING = 'SET_MOBILE_REQUEST_LIST_ING';
export const SET_MOBILE_REQUEST_LIST_END = 'SET_MOBILE_REQUEST_LIST_END';
export const SET_MOBILE_REQUEST_VIEW = 'SET_MOBILE_REQUEST_VIEW';
export const SET_MOBILE_ESTIMATE_LIST = 'SET_MOBILE_ESTIMATE_LIST';
export const SET_MOBILE_ESTIMATE_GROUP_LIST = 'SET_MOBILE_ESTIMATE_GROUP_LIST';
export const SET_MOBILE_ESTIMATE_DETAIL = 'SET_MOBILE_ESTIMATE_DETAIL';
export const SET_MOBILE_SERVICE_LIST = 'SET_MOBILE_SERVICE_LIST';
export const SET_MOBILE_PROMISE = 'SET_MOBILE_PROMISE';
export const SET_MOBILE_PROMISE_LIST = 'SET_MOBILE_PROMISE_LIST';
export const SET_MOBILE_ESTIMATE_PREVIEW = 'SET_MOBILE_ESTIMATE_PREVIEW';
export const SET_MOBILE_ESTIMATE_NEW_CNT = 'SET_MOBILE_ESTIMATE_NEW_CNT';
export const SET_MOBILE_PROMISE_NEW_CNT = 'SET_MOBILE_PROMISE_NEW_CNT';
export const SET_MOBILE_INSURANCE_LIST = 'SET_MOBILE_INSURANCE_LIST';
export const CREATE_MOBILE_APPLY_ONLINE = 'CREATE_MOBILE_APPLY_ONLINE';
export const CREATE_MOBILE_APPLY_VISIT = 'CREATE_MOBILE_APPLY_VISIT';
export const SELECT_MOBILE_APPLY_DETAIL = 'SELECT_MOBILE_APPLY_DETAIL';
export const SET_MOBILE_CHAT_ESTIMATE_LIST = 'SET_MOBILE_CHAT_ESTIMATE_LIST';
export const SET_MOBILE_APPLY_CNT_NEW = 'SET_MOBILE_APPLY_CNT_NEW';
export const UPDATE_MOBILE_ITEM_BOOKMARK = 'UPDATE_MOBILE_ITEM_BOOKMARK';

// //state

// //getters
export const MOBILE_TELECOMS = 'MOBILE_TELECOMS';
export const MOBILE_CATEGORY = 'MOBILE_CATEGORY';
export const MOBILE_DEVICE = 'MOBILE_DEVICE';
export const MOBILE_DEVICE_DETAIL = 'MOBILE_DEVICE_DETAIL';
export const MOBILE_PLAN_CATEGORY = 'MOBILE_PLAN_CATEGORY';
export const MOBILE_PLANS = 'MOBILE_PLANS';
export const MOBILE_PLAN_DETAIL = 'MOBILE_PLAN_DETAIL';
export const MOBILE_REQUEST_LIST_ING = 'MOBILE_REQUEST_LIST_ING';
export const MOBILE_REQUEST_LIST_END = 'MOBILE_REQUEST_LIST_END';
export const MOBILE_REQUEST_VIEW = 'MOBILE_REQUEST_VIEW';
export const MOBILE_ESTIMATE_LIST = 'MOBILE_ESTIMATE_LIST';
export const MOBILE_ESTIMATE_GROUP_LIST = 'MOBILE_ESTIMATE_GROUP_LIST';
export const MOBILE_ESTIMATE_DETAIL = 'MOBILE_ESTIMATE_DETAIL';
export const MOBILE_SERVICE_LIST = 'MOBILE_SERVICE_LIST';
export const MOBILE_PROMISE = 'MOBILE_PROMISE';
export const MOBILE_PROMISE_LIST = 'MOBILE_PROMISE_LIST';
export const MOBILE_ESTIMATE_PREVIEW = 'MOBILE_ESTIMATE_PREVIEW';
export const MOBILE_ESTIMATE_NEW_CNT = 'MOBILE_ESTIMATE_NEW_CNT';
export const MOBILE_PROMISE_NEW_CNT = 'MOBILE_PROMISE_NEW_CNT';
export const MOBILE_INSURANCE_LIST = 'MOBILE_INSURANCE_LIST';
export const MOBILE_CHAT_ESTIMATE_LIST = 'MOBILE_CHAT_ESTIMATE_LIST';
export const MOBILE_APPLY_CNT_NEW = 'MOBILE_APPLY_CNT_NEW';
